import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
type CTAButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
export function CTAButton({
  label = 'OTTIENI MUSICA PRONTA ORA',
  className = '',
  href = '#offer'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} onClick={() => {
    if (isExternal) {
      trackPixelEvent('InitiateCheckout', {
        value: 27,
        currency: 'USD'
      });
    }
  }} className={`inline-flex w-full items-center justify-center gap-3 rounded-full bg-orange px-8 py-4 text-[15px] font-extrabold uppercase tracking-[0.04em] text-white shadow-[0_14px_30px_-14px_rgba(240,134,44,0.8)] transition-colors duration-150 ease-out hover:bg-orange-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy sm:w-auto sm:px-10 sm:text-base sm:tracking-[0.06em] ${className}`} data-id="element-70" data-mp="2g1y0mf9bltm2">
      {label}
      <ArrowRightIcon className="h-4 w-4 flex-none" aria-hidden="true" data-id="element-71" data-mp="1da893bktpxb7" />
    </a>;
}